export async function getCategories(type) {
    const res = await fetch(`/api/categories?type=${type}`, {
        credentials: "include",
    });
    return res.json();
}

export async function createCategory(data) {
    const res = await fetch("/api/categories", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(data),
    });
    return res.json();
}

export async function updateCategory(id, data) {
    const res = await fetch(`/api/categories/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(data),
    });
    return res.json();
}

export async function deleteCategory(id) {
    const res = await fetch(`/api/categories/${id}`, {
        method: "DELETE",
        credentials: "include",
    });
    return res.json();
}
